import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

export default function FixedForm({ onSubmit, submitting }) {
  const [deliverableType, setDeliverableType] = useState("");
  const [deliverableDescription, setDeliverableDescription] = useState("");
  const [date, setDate] = useState(null);
  const [types, setTypes] = useState([]);
  const [typesLoading, setTypesLoading] = useState(true);

  useEffect(() => {
    const fetchTypes = async () => {
      const result = await request("deliverabletype");
      setTypesLoading(false);
      if (result?.success) setTypes(result.types || []);
    };
    fetchTypes();
  }, []);

  const handleSubmit = () => {
    if (!deliverableType) {
      toast.error("Please select a deliverable type");
      return;
    }
    if (!date) {
      toast.error("Please select a completion date");
      return;
    }
    onSubmit({
      workType: "fixed",
      deliverableType,
      deliverableDescription,
      date: dayjs(date).format("YYYY-MM-DD"),
      completionStatus: "complete",
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
        {typesLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <FormControl fullWidth>
              <InputLabel>Deliverable Type</InputLabel>
              <Select
                value={deliverableType}
                label="Deliverable Type"
                onChange={(e) => setDeliverableType(e.target.value)}
              >
                {types.map((t) => (
                  <MenuItem key={t._id} value={t._id}>
                    {t.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <DatePicker
              label="Completion Date"
              value={date}
              onChange={setDate}
              disableFuture
              slotProps={{ textField: { fullWidth: true } }}
            />
            <TextField
              label="Notes (optional)"
              multiline
              rows={4}
              fullWidth
              value={deliverableDescription}
              onChange={(e) => setDeliverableDescription(e.target.value)}
            />
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={handleSubmit}
              disabled={submitting}
              startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : null}
              sx={{ py: 1.5 }}
            >
              Submit
            </Button>
          </>
        )}
      </Box>
    </LocalizationProvider>
  );
}
